import { gql } from '@apollo/client';

/**
 * AB 地址映射类型（与后端 AbAddressMappingType 严格一致）
 * reviewStatus: 0 待审核 / 1 已通过 / 2 已拒绝
 */
export interface AbAddressMappingType {
  id: string;
  hubId: string;
  hubName?: string | null;
  aFullAddress?: string | null;
  bFullAddress?: string | null;
  reason?: string | null;
  reporterAccountId?: string | null;
  reporterName?: string | null;
  reviewStatus: number;
  reviewNote?: string | null;
  reviewerName?: string | null;
  reviewedAt?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface AbAddressMappingPageResponse {
  content: AbAddressMappingType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface GetAbAddressMappingListingResponse {
  getAbAddressMappingListing: AbAddressMappingPageResponse;
}

export interface GetAbAddressMappingByIdResponse {
  getAbAddressMappingById: AbAddressMappingType | null;
}

export interface CreateAbAddressMappingResponse {
  createAbAddressMapping: AbAddressMappingType;
}

export interface DeleteAbAddressMappingResponse {
  deleteAbAddressMapping: boolean;
}

export interface CreateAbAddressMappingInput {
  hubId: string;
  aFullAddress: string;
  bFullAddress: string;
  reason: string;
}

const AB_ADDRESS_MAPPING_FIELDS = `
  id
  hubId
  hubName
  aFullAddress
  bFullAddress
  reason
  reporterAccountId
  reporterName
  reviewStatus
  reviewNote
  reviewerName
  reviewedAt
  createdAt
  updatedAt
`;

export const GET_AB_ADDRESS_MAPPING_LISTING = gql`
  query GetAbAddressMappingListing(
    $hubId: Long!
    $id: Long
    $aAddress: String
    $bAddress: String
    $reporterName: String
    $status: Int
    $page: Int!
    $size: Int!
  ) {
    getAbAddressMappingListing(
      hubId: $hubId
      id: $id
      aAddress: $aAddress
      bAddress: $bAddress
      reporterName: $reporterName
      status: $status
      page: $page
      size: $size
    ) {
      content {
        ${AB_ADDRESS_MAPPING_FIELDS}
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const GET_AB_ADDRESS_MAPPING_BY_ID = gql`
  query GetAbAddressMappingById($id: Long!) {
    getAbAddressMappingById(id: $id) {
      ${AB_ADDRESS_MAPPING_FIELDS}
    }
  }
`;

export const CREATE_AB_ADDRESS_MAPPING = gql`
  mutation CreateAbAddressMapping($input: CreateAbAddressMappingInput!) {
    createAbAddressMapping(input: $input) {
      ${AB_ADDRESS_MAPPING_FIELDS}
    }
  }
`;

export const DELETE_AB_ADDRESS_MAPPING = gql`
  mutation DeleteAbAddressMapping($id: Long!) {
    deleteAbAddressMapping(id: $id)
  }
`;
